import { useEffect, useState } from 'react'
import axios from 'axios';
import useQueryLinkNavigate from '../../../hooks/useQueryLinkNavigate';
import useQueryString from '../../../hooks/useQueryString';
import { useMenuStore } from '../../../zustand/store/useMenuStore';
import useModalStore from '../../../zustand/store/useModalStore';
import { useShallow } from 'zustand/shallow';
import Loading from '../../../component/common/loading/Loading';
import ExcelDownload from '../../../component/common/button/ExcelDownload';
import Pagination from '../../../component/common/dataGrid/Pagination';
import { decodeHtmlEntities } from '../../../utils/htmlEntity.js';

import '../../../css/data-grid.css';
import * as Icons from '../../../images/icons/icons_component';
import * as Theme from '../../../images/icons/icons_theme';
import { useIs19Inch } from '../../../hooks/useBreakPoint';

const decodeHtmlEntity = (str) => {
    if (!str) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.documentElement.textContent || '';
};

const NewBoardList = ({boardTypeCode}) => {
    
    const { returnPage } = useQueryLinkNavigate();
    
    const userId = localStorage.getItem('id');
    // 게시판 관리자는 인트라넷과 같이 등급(J001 · J002)만 본다(관리자 표시 · 롤과 상관없다)
    const admin = ['J001', 'J002'].includes(localStorage.getItem('userAuth'));

    const permissions = useMenuStore(state => state.permissions);
    // 글쓰기는 관리자도 메뉴 권한(등록·수정 UPYN)을 따른다. 관리자(admin)는 비밀글 · 첨부파일 · 기관명 열에만 쓴다
    const canWrite = permissions?.UPYN === 'Y';

    // modal open function
    const [showNotiModal, showPromptModal] = useModalStore(useShallow((state) => [state.showNotiModal, state.showPromptModal]));

    // 쿼리스트링 불러오기
    const { boardSearchObj, pageNo, setBoardParams, searchParamsStr } = useQueryString(boardTypeCode);
    // 입력값 임시 저장 상태
    const [ tempSearch, setTempSearch ] = useState(boardSearchObj);

    // 공지사항, 자료실
    const head1 = ['번호','제목','등록자','등록일','조회확인','첨부파일'];
    const column1 = ['RNUM','NTT_TIL','BOARDNAME','REGDAY','READCOUNT',''];
    const col1 = ['5%', '55%', '10%', '10%', '10%', '10%'];

    // 업무공유 게시판
    const head2 = ['번호','분류','제목','등록자','지역','의료기관명','등록일','조회확인','첨부파일'];
    const column2 = ['RNUM','BSCDDESC','NTT_TIL','BOARDNAME','SIDONAME','EMOGDESC','REGDAY','READCOUNT',''];
    const col2 = ['5%', '11%', '42%', '5%', '7%', '12%', '8%', '5%', '5%'];
    
    const dataHead = (boardTypeCode === 14 ? head2 : head1).filter(v => admin || v !== '의료기관명');
    const dataColumn = (boardTypeCode === 14 ? column2 : column1).filter(v => admin || v !== 'EMOGDESC');
    const colWidth = (boardTypeCode === 14 ? col2 : col1).filter(v => admin || v !== '12%');

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        itemsPerPage: boardTypeCode === 14 ? 14 : 15, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    // 게시판 목록 조회
    const fetchBoard = async (newParams, newPage) => {
        
        const totalObj = Object.assign({}, {mstSno : boardTypeCode, nttResId: userId, itemsPerPage: pageInfo.itemsPerPage, currentPage: newPage}, newParams);

        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading : true
        }));

        try {
            const response = await axios.get('/commonapi/selectBoardContents.do',
                { params: totalObj }
            );
            setState(prev => ({
                ...prev,
                dataList: response.data.boardContents,
                isSearched: true,
                isLoading : false
            }));
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data.boardContentsCount
            }));
            setTempSearch(newParams);
        } catch(e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const onSearch = () => {
        setBoardParams({...tempSearch, page: 1});
    };
    
    // 페이지네이션 handler
    const onHandlePage = (page) => {
        setBoardParams({ ...boardSearchObj, page: page });
    };

    const paginationInfo = {
        ...pageInfo,
        currentPage: pageNo || 1,
        onPageChange: onHandlePage,
    }

    // 업무공유게시판용 지역 list 조회
    const [locaList, setLocaList] = useState([]);

    const fetchLocaData = async () => {
        try {
            const response = await axios.get('/ptmiapi/listInfo.do');
            setLocaList(response.data.optionList.loca || []);
        } catch (error) {
            console.error('초기 데이터 로딩 중 오류 발생:', error);
        }
    };

    // 엔터 이벤트 추가
    const activeEnter = (e) => {
        if(e.key === 'Enter') {
            setBoardParams({...tempSearch, page: 1});
        }
    }

    // 임시 state에 입력값 저장
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTempSearch(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // 업무공유 게시판 - 게시글 종류 선택 시 바로 data 조회
    const handleRadioSearch = (e) => {
        const nextParams = { ...tempSearch, [e.target.name]: e.target.value };
        setBoardParams({...nextParams, page: 1});
    };
    
    // 상세페이지 이동
    const showDetailBoard = async (NTT_SNO, pwdPost, myPost) => {
        // 관리자거나 내가 쓴 글이거나 비밀번호가 없으면 상세페이지 바로 이동
        if (admin || myPost || !pwdPost) {     
            returnPage('detail', NTT_SNO, searchParamsStr);
            return;
        };
        // 그 외 비밀번호 확인 후 상세페이지 이동
        try {
            let errorMsg = '';
            while (true) {
                const result = await showPromptModal( errorMsg  || '비밀글입니다. 비밀번호를 입력하세요.', {
                    placeholder: '비밀번호 입력',
                    type: 'password'
                });
                // 취소 누르면 종료
                if(!result.result) return;
                
                const params = {
                    nttSno: NTT_SNO,
                    nttPwd: result.value
                };
                // 비밀번호 확인(주소에 남지 않게 본문으로 보낸다). 맞으면 서버 세션이 이 글 열람을 허용한다
                const response = await axios.post('/commonapi/boardPwdCheck.do', params);
                // 비밀번호 일치하면 이동
                if(response.data) {
                    returnPage('detail', NTT_SNO, searchParamsStr);
                    return;
                }
                // 비밀번호 미 일치 시 에러메세지 띄우고 while문 반복
                errorMsg = '비밀번호가 일치하지 않습니다.\n다시 입력해주세요.';
            }
        } catch(e) {
            console.error('비밀번호 체크 중 오류 발생', e);
        }
    };

    // 파일 다운로드
    const fileDown = async (myPost) => {
        if(boardTypeCode !== 14 || (boardTypeCode === 14 && (admin || myPost))) {
            console.log('file down');
        } else {
            showNotiModal('첨부파일은 관리자이거나 등록자인 경우에만 다운로드 가능합니다.');
        }
    };

    // 업무공유 게시판 - 게시판 분류 수정내역 팝업
    const ModListPopup = (Id, No) => {
        const senData = {
            mstSno: Id,
            nttSno: No,
        };
        localStorage.setItem('boardModData', JSON.stringify(senData));
        let popup = null;
        popup = window.open('/popup/board_mod_list_popup', "팝업", "scrollbars=0, resizable=0, width=700, height=400, top=30, left=30");
    }

    // 업무공유 게시판 - 안내 메시지 팝업
    const noticePopup = () => {
        let popup = null;
        if(boardTypeCode === 14) {
            popup = window.open('/popup/board_notice_popup', "팝업", "scrollbars=0, resizable=0, width=500, height=400, top=30, left=30");
        }
    }

    // 오늘 하루 보지 않기 설정
    useEffect(() => {
        const today = new Date().toISOString().slice(0, 10);
        const storageKey = `pophide_board_${userId}`;
        const saved = localStorage.getItem(storageKey);

        if (saved !== today) {
            noticePopup();
        };
    }, [boardTypeCode]);

    useEffect(() => {
        fetchBoard(boardSearchObj, Number(pageNo));
        if(boardTypeCode === 14) fetchLocaData();
    }, [boardTypeCode, searchParamsStr]);

    const is19Inch = useIs19Inch();
    
    return (
        <>
            {boardTypeCode !== 14 ? <hr className='border-t-2 ho_border_primary mb-3'/> :
                <div className='com-search mb-3'>
                    <table>
                        <colgroup>
                            <col width='8%' />
                            <col width='30%' />
                            <col width='8%' />
                            <col width='23%' />
                            <col width='8%' />
                            <col width='23%' />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>등록일</th>
                                <td>
                                    <input
                                        type='date'
                                        name='searchStrStartday'
                                        value={tempSearch.searchStrStartday}
                                        onChange={handleInputChange}
                                        max={tempSearch.searchStrEndday}
                                    />
                                    &nbsp;~&nbsp;
                                    <input
                                        type='date'
                                        name='searchStrEndday'
                                        value={tempSearch.searchStrEndday}
                                        onChange={handleInputChange}
                                        min={tempSearch.searchStrStartday}
                                        max={new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0]}
                                    />
                                </td>
                                <th>지역</th>
                                <td>
                                    <select
                                        name='searchLoca'
                                        className='w-full'
                                        value={tempSearch.searchLoca}
                                        onChange={handleInputChange}
                                    >
                                        <option value='all'>전체</option>
                                        {locaList.map(loca => (
                                            <option key={loca.bscdminr} value={loca.bscdminr}>
                                                {loca.bscddesc}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                                <th>분류</th>
                                <td>
                                    <select
                                        id='searchNtc'
                                        name='searchNtc'
                                        value={tempSearch.searchNtc}
                                        onChange={handleInputChange}
                                        className='w-full'
                                    >
                                        <option value='all'>전체</option>
                                        <option value='12'>권역외상센터</option>
                                        <option value='10'>외상등록체계(입력)</option>
                                        <option value='06'>외상등록체계(시스템)</option>
                                        <option value='02'>표준등록체계(입력)</option>
                                        <option value='05'>표준등록체계(시스템)</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
            <div className='search_btn_wrapper pt-0'>
                <div className={`flex ${is19Inch ? 'gap-2' : 'gap-10'}`}>
                    <span className='total_items whitespace-no-wrap'>전체&nbsp;<strong className='ho_primary'>{pageInfo.totalItems}</strong>건</span>
                    {boardTypeCode === 14 &&
                        <div className='flex gap-2'>
                            <div className='flex '>
                                <input type='radio' name='searchBoardContent' id='searchBoardContent'
                                    value='all'
                                    checked={tempSearch.searchBoardContent === 'all'}
                                    onChange={handleRadioSearch}
                                />
                                <label htmlFor='searchBoardContent' className='whitespace-no-wrap'>전체</label>
                            </div>
                            <div className='flex'>
                                <input type='radio' name='searchBoardContent' id='searchBoardContent_registerBoard'
                                    value='registerBoard'
                                    checked={tempSearch.searchBoardContent === 'registerBoard'}
                                    onChange={handleRadioSearch}
                                />
                                <label htmlFor='searchBoardContent_registerBoard' className='whitespace-no-wrap'>등록 게시물</label>
                            </div>
                            <div className='flex'>
                                <input type='radio' name='searchBoardContent' id='searchBoardContent_replyBoard'
                                    value='replyBoard'
                                    checked={tempSearch.searchBoardContent === 'replyBoard'}
                                    onChange={handleRadioSearch}
                                />
                                <label htmlFor='searchBoardContent_replyBoard' className='whitespace-no-wrap'>답글 게시물</label>
                            </div>
                            <div className='flex'>
                                <input type='radio' name='searchBoardContent' id='searchBoardContent_registerReply'
                                    value='registerReply'
                                    checked={tempSearch.searchBoardContent === 'registerReply'}
                                    onChange={handleRadioSearch}
                                />
                                <label htmlFor='searchBoardContent_registerReply' className='whitespace-no-wrap'>등록한 답글</label>
                            </div>
                        </div>
                    }
                </div>
                <div className='btn_container'>
                    <select
                        name='searchContent'
                        className='page_select' 
                        value={tempSearch?.searchContent || 'title'}
                        onChange={handleInputChange}
                    >
                        <option value='title'>제목</option>
                        <option value='content'>내용</option>
                        <option value='registerian'>등록자</option>
                        <option value='titleContent'>제목+내용</option>
                    </select>
                    <input
                        type='text'
                        name='searchText'
                        className='input_style' 
                        value={tempSearch?.searchText || ''}
                        onChange={handleInputChange}
                        onKeyDown={(e) => activeEnter(e)}
                    />
                    <button onClick={() => onSearch()} disabled={state.isLoading ? 'disabled' : ''} className='search_btn w-24 h-7 bg_ho_primary'><Icons.Search16w/>검색</button>
                    <ExcelDownload 
                        excelHead = {dataHead}
                        excelData = {state?.dataList}
                        searched = {true}
                        dataCode = {dataColumn}
                        excelFileName = {`${boardTypeCode === 11 ? '공지사항' : boardTypeCode === 3 ? '자료실' : '업무공유 게시판'} 목록`}
                    />
                </div>
            </div>
            {state.isLoading ? <Loading /> :
                <>
                    <div className='flex flex-col overflow-auto'>
                        <hr className={`border-t-2 ho_border_soft`}/>
                        <div className='data_grid_container overflow-auto'>
                            <div className={`data_list_table overflow-auto ${state.isSearched ? 'grid-animation' : ''}`}>
                                <table>
                                    <colgroup>
                                        {colWidth.length > 0 && colWidth.map((per, idx) => <col key={idx} width={per} /> )}
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            {dataHead.map((content, index) => (
                                                <th key={index}>
                                                    {content}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!state.dataList || state.dataList.length === 0 ? (
                                            <tr>
                                                <td colSpan={dataHead.length+1} className='empty_box'>
                                                    <span className='data_empty bg_ho_odd'>
                                                        <Icons.EmptyDalgu/> 관련 데이터가 없습니다.
                                                    </span>
                                                </td>
                                            </tr>
                                        ) : (
                                            state.dataList.map((item, rowIndex) => {
                                                const gridColor = rowIndex % 2 === 0 ? 'bg_ho_odd' : '';
                                                const noti = item.RNUM === '공지';
                                                const modCat = item.MOD_YN === 'Y';
                                                const cmtsCnt = item.CMTS_CNT > 0;
                                                const newPost = item.NEW_YN === 'Y';
                                                const pwdPost = item.PWDYN === 'Y';
                                                const myPost = item.MY_YN === 'Y';
                                                const fileY = item.ATT_FIL_NAM1 || item.ATT_FIL_NAM1 || item.ATT_FIL_NAM1;
                                                return (
                                                    <tr key={rowIndex} className={`ho_bright_color_h h_icon_box ${gridColor} ${noti ? 'ho_color' : ''}`}>
                                                        {dataColumn.map((idx, colIndex) => (
                                                            colIndex === 1 + (item.MST_SNO === 14 ? 1 : 0) ? (
                                                                <td key={colIndex}>
                                                                    <div className='cursor-pointer flex gap-1 justify-center items-center'
                                                                        role='link' tabIndex={0}
                                                                        onClick={() => showDetailBoard(item.NTT_SNO, pwdPost, myPost)}
                                                                        onKeyDown={(e) => {
                                                                            if(e.key === 'Enter' || e.key === ' ') {
                                                                                e.preventDefault();
                                                                                showDetailBoard(item.NTT_SNO, pwdPost, myPost);
                                                                            }
                                                                        }}>
                                                                        {/* 답글 여부 표시 */}
                                                                        {item.NTT_RPY_LVL > 1 &&
                                                                            <div className='inline-flex items-center leading-4 mr-1-1 st_primary'>
                                                                                <span>↳</span>
                                                                                <span className='bold relative text-xxs' style={{ top: '-4px', marginLeft: '1px' }}>
                                                                                    {item.NTT_RPY_LVL -1}
                                                                                </span>
                                                                            </div>
                                                                        }
                                                                        {decodeHtmlEntities(item[idx])}
                                                                        {cmtsCnt && <span className='tr_color'>({item.CMTS_CNT})</span>}
                                                                        {newPost && <Icons.BoardIcoNew16/>}
                                                                        {pwdPost && <Theme.Pwd16 className='ho_primary'/>}
                                                                    </div>
                                                                </td>
                                                            ) : colIndex === 5 + (item.MST_SNO === 14 ? (admin ? 3 : 2) : 0) ? (
                                                                <td key={colIndex}>
                                                                    {!fileY ? '-' :
                                                                        <button className={`justify-items-center ${fileY && 'cursor-pointer'}`} onClick={() => fileY ? fileDown(myPost) : ''}>
                                                                            <div className='icon'>{noti ? <Theme.Download16 className='ho_primary'/> : <Theme.Download16 className='co_black' />}</div>
                                                                            <div className='hover_icon'><Theme.Download16 className='ho_bright'/></div>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            ) : <td key={colIndex}>
                                                                    <div className='flex gap-1 justify-center items-center'>
                                                                        {decodeHtmlEntities(item[idx])}
                                                                        <span className='cursor-pointer' onClick={() => ModListPopup(item.MST_SNO, item.NTT_SNO)}>
                                                                            {colIndex === 1 && item.MST_SNO === 14 && modCat && <Icons.BoardIconModCat16/>}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                        ))}
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr className='co_border_gray' />
                    </div>
                    <div className={`flex ${canWrite ? 'justify-between' : 'justify-center'}`}>
                        {canWrite ? <div></div> : ''}
                        {state.dataList.length === 0  ? (
                            <br />
                        ) : (
                            <Pagination
                                paginationInfo={paginationInfo}
                            />
                        )}
                        {canWrite ?
                            <div className='mt-3'>
                                <div className='flex gap-2'>
                                    <button onClick={() => returnPage('write', '', searchParamsStr)} className='comm_btn bg_ho_primary'>등록</button>
                                </div>
                            </div>
                        : ''}
                    </div>
                </>
            }
        </>
    )
}

export default NewBoardList;